import { useState, useEffect } from 'react';
import axios from 'utils/axios';
import { API_ENDPOINTS } from 'utils/constants';
import { PUBLIC_SITE_URL } from 'utils/externalLinks';

/**
 * Информация о приложении для UI (версия, бета, дата релиза, changelog).
 * Источник: GET /api/public/app-info (system_settings app_public_* + env APP_PUBLIC_*).
 */
const FALLBACK = {
  version: '0.9',
  beta: true,
  releaseDate: '2026-09-16T17:00:00+03:00',
  releaseDateFormatted: '16.09.2026',
  changelogUrl: `${PUBLIC_SITE_URL}/changelog`,
  betaLaunchNote: 'Запущена: 26 марта 2026, 23:59',
  loading: true,
};

export const useAppInfo = () => {
  const [appInfo, setAppInfo] = useState(FALLBACK);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await axios.get(API_ENDPOINTS.PUBLIC_APP_INFO, { timeout: 8000 });
        const d = res?.data?.data;
        if (!cancelled && res?.data?.success && d && typeof d === 'object') {
          setAppInfo({
            version: d.version != null ? String(d.version) : FALLBACK.version,
            beta: typeof d.beta === 'boolean' ? d.beta : FALLBACK.beta,
            releaseDate: d.releaseDate != null ? String(d.releaseDate) : FALLBACK.releaseDate,
            releaseDateFormatted:
              d.releaseDateFormatted != null ? String(d.releaseDateFormatted) : FALLBACK.releaseDateFormatted,
            changelogUrl: d.changelogUrl != null ? String(d.changelogUrl) : FALLBACK.changelogUrl,
            betaLaunchNote:
              d.betaLaunchNote != null ? String(d.betaLaunchNote) : FALLBACK.betaLaunchNote,
            loading: false,
          });
          return;
        }
      } catch (_e) {
        /* сеть / 5xx — остаётся FALLBACK, loading снимаем */
      }
      if (!cancelled) {
        setAppInfo((prev) => ({ ...prev, loading: false }));
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return appInfo;
};
